module.exports = __webpack_public_path__ + "img/woody_hero_mobile.7333fe7b.jpg";